/*
 * @Author: wuchenge
 * @Date:   2022-03-25 11:13:40
 * @Last Modified by:   无尘阁
 * @Last Modified time: 2022-03-25 12:10:15
 */

import { connect } from "react-redux";
import { useState } from "react";

import {
  SearchInfo,
  SearchInfoTitle,
  SearchInfoSwitch,
  SearchInfoList,
  SearchInfoItem,
} from "./style";
import { actions } from "./store";

const Hot = ({
  list,
  page,
  focused,
  totalPage,
  handleMouseEnter,
  handleMouseLeave,
  handleChangePage,
  setKeyword,
}) => {
  const [spinIcon, setSpinIcon] = useState(null);
  const newList = list.toJS();
  const pageList = [];
  const len = newList.length;
  if (len) {
    for (let i = (page - 1) * 10; i < Math.min(page * 10, len); i++) {
      pageList.push(
        <SearchInfoItem onMouseDown={() => setKeyword(newList[i])} key={newList[i]}>{newList[i]}</SearchInfoItem>
      );
    }
  }

  return (
    <SearchInfo onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <SearchInfoTitle>
        热门搜索
        {totalPage > 1 ? (
          <SearchInfoSwitch
            onClick={() => handleChangePage(page, totalPage, spinIcon)}
          >
            <i
              ref={(icon) => {
                setSpinIcon(icon);
              }}
              className="iconfont spin"
            >
              &#xe851;
            </i>
            换一批
          </SearchInfoSwitch>
        ) : null}
      </SearchInfoTitle>
      <SearchInfoList>{pageList}</SearchInfoList>
    </SearchInfo>
  );
};

const mapState = (state) => {
  return {
    list: state.getIn(["header", "list"]),
    page: state.getIn(["header", "page"]),
    focused: state.getIn(["header", "pfocusedage"]),
    totalPage: state.getIn(["header", "totalPage"]),
  };
};

const mapDispatch = (dispatch) => {
  return {
    handleMouseEnter() {
      dispatch(actions.mouseEnter());
    },
    setKeyword(keyword) {
      dispatch(actions.setKeyword(keyword));
    },
    handleMouseLeave() {
      dispatch(actions.mouseLeave());
    },
    handleChangePage(page, totalPage, spin) {
      let originAngle = spin.style.transform.replace(/[^0-9]/gi, "");
      if (originAngle) {
        originAngle = parseInt(originAngle, 10);
      } else {
        originAngle = 0;
      }
      spin.style.transform = "rotate(" + (originAngle + 360) + "deg)";

      if (page < totalPage) {
        dispatch(actions.changePage(page + 1));
      } else {
        dispatch(actions.changePage(1));
      }
    },
  };
};

export default connect(mapState, mapDispatch)(Hot);
